(function () {
  var el = document.querySelector('.boutique-map');
  if (!el) return;

  var markUrl = el.dataset.markUrl;
  var lat = parseFloat(el.dataset.lat) || 41.4590;
  var lng = parseFloat(el.dataset.lng) || -81.9320;
  var key = 'AIzaSyAW4FC0dQ5azNz5JGZoXHkcu0vQ5_GJPuE';

  var script = document.createElement('script');
  script.async = true;
  script.src = 'https://maps.googleapis.com/maps/api/js?key=' + key;
  script.onload = function () {
    var map = new google.maps.Map(el, {
      center: { lat: lat, lng: lng },
      zoom: 10,
      disableDefaultUI: true,
      styles: [
        { featureType: 'all', elementType: 'geometry', stylers: [{ color: '#e9e9e9' }] },
        { featureType: 'all', elementType: 'labels.text.fill', stylers: [{ color: '#000000' }] },
        { featureType: 'all', elementType: 'labels.text.stroke', stylers: [{ color: '#ffffff' }] },
        { featureType: 'administrative', elementType: 'geometry', stylers: [{ visibility: 'off' }] },
        { featureType: 'administrative.country', elementType: 'geometry.stroke', stylers: [{ color: '#7f7f7f' }] },
        { featureType: 'administrative.country', elementType: 'labels.text', stylers: [{ visibility: 'on' }] },
        { featureType: 'administrative.province', elementType: 'geometry.stroke', stylers: [{ color: '#7f7f7f' }] },
        { featureType: 'administrative.province', elementType: 'labels.text', stylers: [{ visibility: 'on' }] },
        { featureType: 'administrative.locality', elementType: 'geometry.stroke', stylers: [{ color: '#7f7f7f' }] },
        { featureType: 'administrative.locality', elementType: 'labels.text', stylers: [{ visibility: 'on' }] },
        { featureType: 'administrative.neighborhood', elementType: 'geometry', stylers: [{ visibility: 'off' }] },
        { featureType: 'administrative.land_parcel', elementType: 'geometry.stroke', stylers: [{ color: '#7f7f7f' }] },
        { featureType: 'administrative.land_parcel', elementType: 'labels.text', stylers: [{ visibility: 'off' }] },
        { featureType: 'administrative.land_parcel', elementType: 'labels.text.fill', stylers: [{ visibility: 'off' }] },
        { featureType: 'administrative.land_parcel', elementType: 'labels.text.stroke', stylers: [{ visibility: 'off' }] },
        { featureType: 'administrative.neighborhood', elementType: 'labels.text', stylers: [{ visibility: 'off' }] },
        { featureType: 'poi', elementType: 'labels.text', stylers: [{ visibility: 'off' }] },
        { featureType: 'poi', elementType: 'labels.text.fill', stylers: [{ visibility: 'off' }] },
        { featureType: 'poi', elementType: 'labels.text.stroke', stylers: [{ visibility: 'off' }] },
        { featureType: 'road', elementType: 'geometry', stylers: [{ color: '#ffffff' }] },
        { featureType: 'road', elementType: 'labels.text', stylers: [{ visibility: 'on' }] },
        { featureType: 'road', elementType: 'labels.text.fill', stylers: [{ color: '#000000' }] },
        { featureType: 'road', elementType: 'labels.text.stroke', stylers: [{ color: '#ffffff' }] },
        { featureType: 'transit', elementType: 'labels.text', stylers: [{ visibility: 'off' }] },
        { featureType: 'transit.line', elementType: 'geometry', stylers: [{ color: '#e5e5e5' }] },
        { featureType: 'transit.station', elementType: 'geometry', stylers: [{ color: '#e9e9e9' }] },
        { featureType: 'water', elementType: 'geometry', stylers: [{ color: '#c9c9c9' }] },
        { featureType: 'water', elementType: 'labels.text', stylers: [{ visibility: 'on' }] },
        { featureType: 'water', elementType: 'labels.text.fill', stylers: [{ color: '#000000' }] },
        { featureType: 'water', elementType: 'labels.text.stroke', stylers: [{ color: '#ffffff' }] }
      ]
    });

    new google.maps.Marker({
      position: { lat: lat, lng: lng },
      map: map,
      title: 'Boutique',
      icon: {
        url: markUrl,
        scaledSize: new google.maps.Size(30, 40)
      }
    });
  };
  document.body.appendChild(script);
})();
